import React, { Component } from 'react';
import { Grid, Button, Typography, Box, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControlLabel, Checkbox } from '@material-ui/core';
import '../CSS/RemoteReservations.css';
import { getSiteRigDiscountExtra, getSpaces, getRemoteExplainations, getParkMapURL, getReservationFields } from '../utils/OpenCampground_Database_Calls'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { format } from 'date-fns';
import dayjs from 'dayjs';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import RemoteSpaceSelect from './RemoteSpaceSelect';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

const useStyles = theme => ({
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
    },
    circularProgress: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        color: '#2dcd7a'
    }
   
});

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

class RemoteReservations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //pre requisit data
            sites: [],
            rigs: [],
            boats: [{"name": "sail","id": 1},{"name": "power","id": 2},{"name": "catamaran","id": 3}],
            extras: [],
            taxes: [],
            requiredFields: [],
            fields:{},

            //form
            checkIn: format(new Date(), 'MM/dd/yyyy'),
            checkOut: '',
            guest: '',
            rigType: '',
            pets: '',
            rigLength: '',
            siteLength: '',
            siteType: 'Any',
            slides: '',
            children: '',
            boatType: '',
            boatDraft:'',
            boatLength:'',
            boatBeam:'',
            e15a:'',
            e30a:'',
            e50a:'',
            e100a:'',
            freshWater:'',
            pumpOut:'',


            //form validation
            formValid: false,

            //view changing variables
            form: true,
            selectSpace: false,

            //spaces
            spaceData: [],

            //popup
            open: false,

            //explainations
            facilities: '',
            additionalDetails: '',
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            rules: '',
            changes: '',
            showBlackoutDates: false,

            //map
            mapURL: null,

            //loader
            loading: true
        };
    }

    async componentDidMount() {
        let siteRigDiscountExtra = await getSiteRigDiscountExtra(this.props.user, this.props.serverName);
        let explainations = await getRemoteExplainations(this.props.user, this.props.serverName)
        let getMapURL = await getParkMapURL(this.props.user, this.props.serverName)
        let fields = await getReservationFields(this.props.user, this.props.serverName)

        // console.log(getMapURL.body.imageUrl)
        this.setState({
            sites: siteRigDiscountExtra[0],
            rigs: siteRigDiscountExtra[1],
            extras: siteRigDiscountExtra[3],
            explainations: explainations,
            facilities: explainations.facilities,
            additionalDetails: explainations.additionalDetails,
            addressLine1: explainations.addressLine1,
            addressLine2: explainations.addressLine2,
            addressLine3: explainations.addressLine3,
            rules: explainations.rules,
            changes: explainations.changes,
            mapURL: getMapURL.body.imageUrl,
            requiredFields: fields?.required_fields,
            fields: fields,
            loading: false

        })
    }

    rigChange = (event) => {
        this.setState({
            rigType: event.target.value
        }, () => {
            this.formValidation();
        })
    };

    boatChange = (event) => {
        this.setState({
            boatType: event.target.value
        }, () => {
            this.formValidation();
        })
    };

    siteChange = (event) => {
        this.setState({
            siteType: event.target.value
        }, () => {
            this.formValidation();
        })
    };

    handleChange = (event) => {
        if (event.target.id === 'e15a' || event.target.id === 'e30a' || event.target.id === 'e50a' || event.target.id === 'e100a' || event.target.id === 'freshWater' || event.target.id === 'pumpOut') {
            this.setState({
                [event.target.id]: event.target.checked
            }, this.formValidation);
        }
        else{
        const { id, value } = event.target;
        const ranges = {
            guests: [0, 999],
            rigLength: [0, 99],
            pets: [0, 9],
            // slides: [0, 9],
            children: [0, 99],
        };

        if (ranges[id]) {
            const [min, max] = ranges[id];
            if (value >= min && value <= max) {
                this.setState({ [id]: value }, this.formValidation);
            }
        } else {
            this.setState({ [id]: value }, this.formValidation);
        }
        }
    }

    isButtonEnabled = () => {
        const { requiredFields, e15a, e30a, e50a, e100a } = this.state;
    
        return requiredFields.every((field) => {
            if (["freshWater", "pumpOut", "startDate", "endDate"].includes(field)) {
                return true;
            }
    
            if (["powerRequirement1","powerRequirement2"].includes(field)) {
                return e15a || e30a || e50a || e100a;
            }
    
            // Default check for other fields
            return this.state[field]?.toString().trim() !== "";
        });

    };

    formValidation = () => {
        let isRequiredFieldsFilled = this.isButtonEnabled()
        // if (this.state.checkIn && this.state.checkOut && (this.state.checkIn < this.state.checkOut) && isRequiredFieldsFilled && 
        //     this.state.guests > 0 && this.state.rigType && this.state.pets >= 0 && this.state.rigLength &&
        //     this.state.siteType && this.state.slides >= 0 && this.state.children >= 0) {
        //     this.setState({
        //         formValid: true
        //     })
        // } else if (this.state.formValid) {
        //     this.setState({
        //         formValid: false
        //     })
        // }
        if (this.state.checkIn && this.state.checkOut && (this.state.checkIn < this.state.checkOut) && isRequiredFieldsFilled ){
        this.setState({
            formValid: true
        })
    } else if (this.state.formValid) {
        this.setState({
            formValid: false
        })
    }
    console.log(this.state.formValid+'validity of the form');
    }

    findSpace = async () => {
        let inDate = this.state.checkIn.format('YYYY-MM-DD');
        let outDate = this.state.checkOut.format('YYYY-MM-DD');
        const isUnderBlackout = this.props.blackoutDates.some((blackout) => {
            const start = dayjs(blackout.start);
            const end = dayjs(blackout.end);
            return (
                dayjs(inDate).isBetween(start, end, 'day', '[]') ||
                dayjs(outDate).isBetween(start, end, 'day', '[]') ||
                (dayjs(inDate).isBefore(start) && dayjs(outDate).isAfter(end))
            );
        });

        if (isUnderBlackout) {
            this.setState({ open: true })
        } else {
            let spacesData = await getSpaces(this.props.user, this.props.serverName, outDate, inDate)
            console.log("Space Date: ", spacesData)
            let filteredSpacesData
            if (this.state.siteType === 'Any') {
                filteredSpacesData = spacesData.filter(space => space.remote_reservable)
            } else {
                filteredSpacesData = spacesData.filter(space => (space.sitetype_name === this.state.siteType && space.remote_reservable));
            }
            // filteredSpacesData = spacesData.filter((space) => {
            //     const { siteType, rigType, boatType, e15a, e30a, e50a, e100a, freshWater, pumpOut } = this.state;
            //     return (
            //         (siteType ? space?.sitetype_name === siteType : true) ||
            //         (rigType ? space?.rigType === rigType : true) &&
            //         (boatType ? space.boatType === boatType : true) &&
            //         (e15a ? space?.power_15a === 1 : true) ||
            //         (e30a ? space?.power_30a === 1 : true) ||
            //         (e50a ? space?.power_50a === 1 : true) ||
            //         (e100a ? space?.power_100a === 1 : true) ||
            //         (freshWater ? space?.water === 1 : true) ||
            //         (pumpOut ? space?.pumpOut === 1 : true)
            //     );
            // });
            console.log("Filtered Space Date: ", filteredSpacesData)
            this.setState({
                checkIn: inDate,
                checkOut: outDate,
                formValid: false,
                form: false,
                selectSpace: true,
                spaceData: filteredSpacesData
            })
        }
    }

    updateSpace = (spacesData) => {
        this.setState({
            spaceData: spacesData
        })
    }

    isDateInBlackout = (date) => {
        return this.props.blackoutDates.some((blackout) => {
            const start = dayjs(blackout.start);
            const end = dayjs(blackout.end);
            return date.isBetween(start, end, 'day', '[]');
        });
    };

    render() {
        const { classes } = this.props;
        {if(this.state.loading){
            return <CircularProgress className={classes.circularProgress} />
        }}
        return (
            <Grid className='remoteReservationList'>
                {this.state.form
                    ?
                    <>
                        <ThemeProvider theme={theme}>
                            <Dialog open={this.state.open} onClose={() => this.setState({ confirmationOpen: false })} classes={{ paper: classes.dialogPaper }}>
                                <DialogTitle>Dates Cannot Be Booked</DialogTitle>
                                <DialogContent>
                                    You have selected dates on or during a blackout period. Please contact the staff to complete this reservation.
                                </DialogContent>
                                <DialogActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button onClick={() => this.setState({ open: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                        Close
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Box className='infoBox'>
                                <Typography className='infoBarTypo'>Welcome To {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)} Online Reservation System</Typography>
                                {this.props.blackoutDates.length
                                    ?
                                    <>
                                        {this.state.showBlackoutDates
                                            ? <Button className='blackoutButton' onClick={() => { this.setState({ showBlackoutDates: false }) }}>Back To Reservation</Button>
                                            : <Button className='blackoutButton' onClick={() => { this.setState({ showBlackoutDates: true }) }}>Show Blackout Dates</Button>
                                        }
                                    </>
                                    : null
                                }

                            </Box>
                            {this.state.showBlackoutDates
                                ?
                                <div className='remoteBlackoutDates'>
                                    <TableContainer component={Paper} style={{ marginTop: '5%' }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ border: '1px solid #efefef' }}>Blackout Name</TableCell>
                                                    <TableCell style={{ border: '1px solid #efefef' }}>Start Date</TableCell>
                                                    <TableCell style={{ border: '1px solid #efefef' }}>End Date</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.props.blackoutDates.map((blackout) => (
                                                    <TableRow key={blackout.id}>
                                                        <TableCell style={{ border: '2px solid #efefef' }}>{blackout.name}</TableCell>
                                                        <TableCell style={{ border: '2px solid #efefef' }}>{blackout.start}</TableCell>
                                                        <TableCell style={{ border: '2px solid #efefef' }}>{blackout.end}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                :
                                <>
                                    <Box className='remoteResBox'>
                                        <Box className='remoteResFormBox'>
                                        <Typography className='remoteReservationstypography' style={{ textAlign: "center", marginBottom:'0px' }}>Create Reservations</Typography>
                                        </Box>
                                        <Typography className='remoteReservationstypography' style={{ textAlign: "center", marginBottom:'20px', color: 'red' }}>(* All fields are required)</Typography>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={6}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        id='checkIn'
                                                        label='Check In*'
                                                        className='remoteResLeft'
                                                        disablePast
                                                        shouldDisableDate={(date) => this.isDateInBlackout(date)}
                                                        onChange={(date) => {
                                                            this.setState({ checkIn: date }, () => {
                                                                this.formValidation();
                                                            })
                                                        }}
                                                    />
                                                </LocalizationProvider></Grid>
                                            <Grid item xs={12} sm={6}> <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    id='checkOut'
                                                    label='Check Out*'
                                                    className='remoteResMiddle'
                                                    minDate={dayjs(this.state.checkIn).add(1, 'day')}
                                                    shouldDisableDate={(date) => this.isDateInBlackout(date)}
                                                    onChange={(date) => {
                                                        this.setState({ checkOut: date }, () => {
                                                            this.formValidation();
                                                        })
                                                    }}
                                                />
                                            </LocalizationProvider></Grid>
                                        </Grid>
                                        <Box
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(2, 1fr)",
                                            gap: "8px",
                                            alignItems: "center",
                                            }}
                                        >


                                        {/* <Grid container spacing={1}> */}
                                            {this.state.fields?.use_guest ? (<Grid item>
                                                <TextField id="guest" label={"Number of Adults"+(this.state.requiredFields.includes('guest')?"*":"")} type="number"
                                                    className='remoteResRight' onChange={this.handleChange}
                                                    value={this.state.guests} inputProps={{ min: 0, max: 999 }}
                                                />
                                            </Grid>):null}
                                            {this.state.fields?.use_children ? (<Grid item>
                                                <TextField id="children" label={"Children"+(this.state.requiredFields.includes('children')?"*":"")} type="number"
                                                    className='remoteResRight' onChange={this.handleChange}
                                                    value={this.state.children} inputProps={{ min: 0, max: 99 }}
                                                />
                                            </Grid>):null}
                                        {/* </Grid> */}
                                        {/* <Grid container spacing={1}> */}
                                            {this.state.fields?.use_pets ? (<Grid item>
                                                <TextField id="pets" label={"Pets"+(this.state.requiredFields.includes('pets')?"*":"")} type="number"
                                                    className='remoteResMiddle' onChange={this.handleChange}
                                                    value={this.state.pets} inputProps={{ min: 0, max: 9 }}
                                                />
                                            </Grid>):null}
                                            {this.state.fields?.use_rig_length ? (<Grid item>
                                                <TextField id="rigLength" label={"Rig Length"+(this.state.requiredFields.includes('rigLength')?"*":"")} type="number"
                                                    className='remoteResRight' onChange={this.handleChange}
                                                    value={this.state.rigLength} inputProps={{ min: 0, max: 99 }}
                                                />
                                            </Grid>):null}
                                        {/* </Grid> */}
                                        {/* <Grid container spacing={1}> */}
                                            {this.state.fields?.use_site_type ? (<Grid item>
                                                <FormControl className='remoteResLeft'>
                                                    <InputLabel >{"Site Type"+(this.state.requiredFields.includes('siteType')?"*":"")}</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="siteSelect"
                                                        value={this.state.siteType}
                                                        label={"Site Type"+(this.state.requiredFields.includes('siteType')?"*":"")}
                                                        onChange={this.siteChange}
                                                    >
                                                        <MenuItem value="Any">Any</MenuItem>
                                                        {this.state.sites.map((site, index) => (
                                                            <MenuItem key={index} value={site.name}>
                                                                {site.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>):null}

                                            {this.state.fields?.use_rig_type ? (<Grid item>
                                                <FormControl className='remoteResLeft'>
                                                    <InputLabel >{"Rig Type"+(this.state.requiredFields.includes('rigType')?"*":"")}</InputLabel>
                                                    <Select
                                                        labelId="rig"
                                                        id="rigSelect"
                                                        value={this.state.rigType}
                                                        label={"Rig Type"+(this.state.requiredFields.includes('rigType')?"*":"")}
                                                        onChange={this.rigChange}
                                                    >
                                                        {this.state.rigs.map((rig, index) => (
                                                            <MenuItem key={index} value={rig.name}>
                                                                {rig.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>):null}
                                        {/* </Grid> */}
                                        {/* <Grid container spacing={1}> */}
                                            {this.state.fields?.use_boat_type ? (<Grid item>
                                            <FormControl className='remoteResLeft'>
                                                    <InputLabel >{"Boat Type"+(this.state.requiredFields.includes('boatType')?"*":"")}</InputLabel>
                                                    <Select
                                                        labelId="Boat"
                                                        id="boatSelect"
                                                        value={this.state.boatType}
                                                        label={"Boat Type"+(this.state.requiredFields.includes('boatType')?"*":"")}
                                                        onChange={this.boatChange}
                                                    >
                                                        {this.state.boats.map((rig, index) => (
                                                            <MenuItem key={index} value={rig.name}>
                                                                {rig.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>):null}
                                            {this.state.fields?.use_boat_draft ? (<Grid item>
                                                <TextField id="boatDraft" label={"Boat Draft"+(this.state.requiredFields.includes('boatDraft')?"*":"")} type="number"
                                                    className='remoteResRight' onChange={this.handleChange}
                                                    value={this.state.boatDraft} inputProps={{ min: 0, max: 99 }}
                                                />
                                            </Grid>):null}
                                        {/* </Grid> */}
                                        {/* <Grid container spacing={1}> */}
                                            {this.state.fields?.use_boat_length ? (<Grid item >
                                                <TextField id="boatLength" label={"Boat Length"+(this.state.requiredFields.includes('boatLength')?"*":"")} type="number"
                                                    className='remoteResMiddle' onChange={this.handleChange}
                                                    value={this.state.boatLength} inputProps={{ min: 0, max: 9 }}
                                                />
                                            </Grid>):null}
                                            {this.state.fields?.use_boat_beam ? (<Grid item >
                                                <TextField id="boatBeam" label={"Boat Beam"+(this.state.requiredFields.includes('boatBeam')?"*":"")} type="number"
                                                    className='remoteResRight' onChange={this.handleChange}
                                                    value={this.state.boatBeam} inputProps={{ min: 0, max: 99 }}
                                                />
                                            </Grid>):null}
                                        {/* </Grid> */}
                                        {this.state.fields?.use_length ? <Grid item>
                                            <TextField id="siteLength" label={"Site Length"+(this.state.requiredFields.includes('siteLength')?"*":"")} type="number"
                                                className='remoteResMiddle' onChange={this.handleChange}
                                                value={this.state.siteLength} inputProps={{ min: 0, max: 99 }}
                                            />
                                        </Grid> :null
                                        }
                                        </Box>
                                        <Grid container spacing={1}>
                                            {this.state.fields?.use_power1 ? <div style={{ display: 'flex', alignItems: 'center', gap: '16px', padding:'4px' }}>
                                                <FormControlLabel
                                                label={"Power 15a"}
                                                control={
                                                <Checkbox id="e15a" color='default' checked={this.state.e15a} onChange={this.handleChange}/>}/>
                                                <FormControlLabel
                                                label={"Power 30a"}
                                                control={
                                                <Checkbox id="e30a" color='default' checked={this.state.e30a} onChange={this.handleChange}/>}/>
                                                <FormControlLabel
                                                label={"Power 50a"}
                                                control={
                                                <Checkbox id="e50a" color='default' checked={this.state.e50a} onChange={this.handleChange}/>}/>
                                            </div>:null}
                                            {this.state.fields?.use_power2 ? <div style={{ display: 'flex', alignItems: 'center', gap: '16px', padding:'4px' }}>
                                                <FormControlLabel
                                                label={"Power 30a"}
                                                control={
                                                <Checkbox id="e30a" color='default' checked={this.state.e30a} onChange={this.handleChange}/>}/>
                                                <FormControlLabel
                                                label={"Power 50a"}
                                                control={
                                                <Checkbox id="e50a" color='default' checked={this.state.e50a} onChange={this.handleChange}/>}/>
                                                <FormControlLabel
                                                label={"Power 100a"}
                                                control={
                                                <Checkbox id="e100a" color='default' checked={this.state.e100a} onChange={this.handleChange}/>}/>
                                            </div>:null}
                                        </Grid>

                                        <Grid container spacing={1}>
                                            {this.state.fields?.use_fresh_water ? (<Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                label={"Fresh Water"}
                                                control={
                                                <Checkbox id="freshWater" color='default' checked={this.state.freshWater} onChange={this.handleChange}/>}/>
                                            </Grid>):null}
                                            {this.state.fields?.use_pump_out ? (<Grid item xs={12} sm={6}>
                                                <FormControlLabel
                                                label={"Pump-out Service"}
                                                control={
                                                <Checkbox id="pumpOut" color='default' checked={this.state.pumpOut} onChange={this.handleChange}/>}/>
                                            </Grid>):null}
                                        </Grid>
                                        <Button className='remoteResButton' style={{marginTop:"5px"}} onClick={this.findSpace} disabled={!this.state.formValid}>Find Space</Button>
                                    </Box>
                                </>
                            }
                        </ThemeProvider>
                    </>
                    : <RemoteSpaceSelect sites={this.state.sites} rigs={this.state.rigs} extras={this.state.extras}
                        checkIn={this.state.checkIn} checkOut={this.state.checkOut} guests={this.state.guest}
                        boatBeam={this.state.boatBeam} boatLength={this.state.boatLength} boatDraft={this.state.boatDraft} siteLength={this.state.siteLength} boatType={this.state.boatType} freshWater={this.state.freshWater} pumpOut={this.state.pumpOut} e15a={this.state.e15a} e30a={this.state.e30a} e50a={this.state.e50a} e100a={this.state.e100a}
                        rigType={this.state.rigType} pets={this.state.pets} rigLength={this.state.rigLength}
                        slides={this.state.slides} children={this.state.children} spaceData={this.state.spaceData}
                        serverName={this.props.serverName} updateSpace={this.updateSpace} allow={this.props.allow} require={this.props.require}
                        facilities={this.state.facilities} additionalDetails={this.state.additionalDetails} addressLine1={this.state.addressLine1}
                        addressLine2={this.state.addressLine2} addressLine3={this.state.addressLine3} rules={this.state.rules}
                        changes={this.state.changes} siteType={this.state.siteType} mapURL={this.state.mapURL} user={this.props.user} />
                }
            </Grid>
        )
    };
};

export default withStyles(useStyles)(RemoteReservations);